import {
    IBasketPrizeCertificateInfoBoxDiscriminator,
    type IBasketPrizeCertificateInfoBoxMaybe
} from 'autogen/swagger/all';
import { usePrizeCertificatesQuery } from 'autogen/swagger/all/hooks';
import Card from 'components/generic/card';
import PrizeCertificate from './PrizeCertificate';

// We don't need these page specific views when we have full pages in React
export default function CheckoutPrizeCertificate({
    model: initialModel
}: { model: IBasketPrizeCertificateInfoBoxMaybe }) {
    const { data: model } = usePrizeCertificatesQuery({ initialData: initialModel });

    if (!model) return null;
    if (
        IBasketPrizeCertificateInfoBoxDiscriminator(
            model,
            (basketPrizeCertModel) => !basketPrizeCertModel.choosablePrizeCertificates.length,
            (notAavailableCertModel) => false,
            () => false
        )
    )
        return null;

    return (
        <Card size={{ xs: 'md', sm: 'xl' }}>
            <Card.Content>
                <PrizeCertificate model={model} />
            </Card.Content>
        </Card>
    );
}
